import axios from "axios";
// const camelcaseKeys = require("camelcase-keys");

const axiosInstance = axios.create();

// Response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Check if error is due to expired token (401)
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      // Keep the Clerk token in place; clearing it caused remount/refetch loops.
      return Promise.reject(
        new Error("Authentication expired. Please login again.")
      );
    }

    return Promise.reject(error);
  }
);
export default class ApiCall {
  // static swrFetcher() {
  //   return (url: string) =>
  //     axiosInstance
  //       .get(url, {
  //         // headers: { Authorization: `Bearer ${localStorage.accessToken}` },
  //       })
  //       .then(({ data }) => data)
  //       .catch(err => {
  //         throw err
  //       });
  // }

  static async get(route: string) {
    try {
      const response = (
        await axiosInstance.get(route, {
          headers: {
            Authorization: `Bearer ${localStorage.accessToken}`,
          },
        })
      ).data;
      return response;
    } catch (err: any) {
      console.error(`ApiCall get err: ${err}`);
      throw err.response?.data;
    }
  }

  static async post(route: string, data: any) {
    try {
      const response = (
        await axiosInstance.post(route, data, {
          headers: {
            Authorization: `Bearer ${
              data.accessToken || localStorage.accessToken
            }`,
          },
        })
      ).data;
      return response;
    } catch (err: any) {
      console.error(`ApiCall post err: ${err}`);
      throw err.response?.data;
    }
  }

  static async update(route: string, data: any) {
    try {
      if (!!data.id) {
        data.id = Number(data.id);
      }
      const response = (
        await axiosInstance.patch(route, data, {
          headers: {
            Authorization: `Bearer ${process.env.accessToken}`,
          },
        })
      ).data;
      return response;
    } catch (err: any) {
      console.error(`ApiCall update err: ${err}`);
      throw err.response?.data;
    }
  }

  static async replace(route: string, data: any) {
    try {
      if (!!data.id) {
        data.id = Number(data.id);
      }
      const response = (
        await axiosInstance.put(route, data, {
          headers: {
            Authorization: `Bearer ${localStorage.accessToken}`,
          },
        })
      ).data;
      return response;
    } catch (err: any) {
      console.error(`ApiCall put err: ${err}`);
      throw err.response?.data;
    }
  }

  static async delete(route: string) {
    try {
      const response = (
        await axiosInstance.delete(route, {
          headers: {
            Authorization: `Bearer ${localStorage.accessToken}`,
          },
        })
      ).data;
      return response;
    } catch (err: any) {
      console.error(`ApiCall delete err: ${err}`);
      throw err.response?.data;
    }
  }

  static async put(route: string, body: object) {
    try {
      const response = (
        await axiosInstance.put(route, body, {
          headers: {
            Authorization: `Bearer ${localStorage.accessToken}`,
          },
        })
      ).data;
      return response;
    } catch (err: any) {
      console.error(`ApiCall put err: ${err}`);
      throw err.response?.data;
    }
  }

  static async login(username: string, password: string) {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API}/she/login`,
        {
          username,
          password,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.accessToken}`,
          },
        }
      );
      return response;
    } catch (err: any) {
      console.error(`ApiCall login err: ${err}`);
      throw err.response?.data;
    }
  }

  // static async getDoc(route, data) {
  //   return await axiosInstance.post(route, data, {
  //     responseType: "blob",
  //     headers: { Authorization: `Bearer ${localStorage.accessToken}` },
  //   });
  // }
}
